import React from 'react'
import axios from 'axios'
import { Cookies } from 'react-cookie'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

class ModalWrap extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			authenticated: false,
			cpassword: '',
			npassword: '',
			rpassword: ''
		}
		this.handleInputChange = this.handleInputChange.bind(this)
	}
	
	handleNext() {
		let cpassword = this.state.cpassword
		if (!cpassword) {
			alert("Please enter current password")
			return
		}
		if (!this.state.authenticated) {
			let url = `http://107.170.197.5:8080/api/users/login`
			let data = JSON.stringify({
				email: this.props.email,
				password: cpassword
			})
			axios.post(url, data, {headers:{'Content-Type':'application/json'}})
			.then((response) => {
				this.setState({
					authenticated: true
				})
				return
			})
			.catch((error) => {
				alert("Incorrect password")
				return
			})
		} else {
			if (!this.state.npassword || !this.state.rpassword) {
				alert("Please complete all fields")
				return
			}
			if (this.state.npassword !== this.state.rpassword) {
				alert("Passwords do not match")
				return
			}
			let url = `http://107.170.197.5:8080/api/users/profile`
			let cookies = new Cookies()
			let token = cookies.get('token')
			let authorization = "Bearer " + token
			let data = JSON.stringify({
				password: this.state.npassword
			})
			axios.patch(url, data, {headers:{'Content-Type':'application/json','Authorization': authorization}})
			.then((response) => {
				alert("Your password has been changed")
				this.props.onClose()
				return
			})
			.catch((error) => {
				alert("Incorrect password")
				return
			})
		}
	}
	
	handleKeyPress(e) {
		if(e.key == 'Enter'){
			this.handleNext()
		}
	}
	
	handleInputChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		
		this.setState({
			[name]: value
		});
	}

	render() {
		const { onClose } = this.props
		return (
			<div className="modal-wrap">
				<div className="modal-header">
					<h5 className="title">Change Password</h5>
					<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={ onClose }>
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div className="modal-body">
					{ !this.state.authenticated ? (
						<div>
							<label>Enter current password</label>
							<input type="password" className="form-control mb-1" name="cpassword" value={this.state.cpassword} onChange={this.handleInputChange} onKeyPress={this.handleKeyPress.bind(this)}/>
							<button type="button" className="btn-login" onClick={ this.handleNext.bind(this) }>Next</button>
						</div>
					):(
						<div>
							<label>Enter new password</label>
							<input type="password" className="form-control mb-1" name="npassword" value={this.state.npassword} onChange={this.handleInputChange} onKeyPress={this.handleKeyPress.bind(this)}/>
							<label>Repeat new password</label>
							<input type="password" className="form-control mb-1" name="rpassword" value={this.state.rpassword} onChange={this.handleInputChange} onKeyPress={this.handleKeyPress.bind(this)}/>
							<button type="button" className="btn-login" onClick={ this.handleNext.bind(this) }>Next</button>
						</div>
					)}
				</div>
			</div>
		)
	}
}

class PasswordModal extends React.Component {
	render() {
		
		const { onOverlay, onClose, isOpen, transitionName, email } = this.props
		
	    if(isOpen){
			return (
				<TransitionGroup>
					<CSSTransition
					 classNames={transitionName}
					 timeout={{ enter: 200, exit: 200 }}
					>
						<div data-modal="true" onClick={ onOverlay } className="module-modal img-modal" >
							<div data-modal="true" className="modal-wrapper">
								<div className="modal-inner">
									<ModalWrap onClose={ onClose } email={ email } />
								</div>
							</div>
						</div>	
					</CSSTransition>
				</TransitionGroup>
			);
		} else {
	        return <TransitionGroup classnames={transitionName} />;
	    }
	    
	}
}

export default PasswordModal


// WEBPACK FOOTER //
// ./src/components/Settings/PasswordModal.js